<template>
    <div :class="{ 'next-background': mode === 'home' && !isIntoIframe }">
        <mainindex>
            <div v-if="!islogmode" class="content">
                <!--<div class="content" v-if="gen._UID && !islogmode">-->
                <!--HEADER-->
                <page-header v-if="!isIntoIframe && mode !== 'home'" :cur-page="mode" :menu-tree="menu" @nav="go($event)" @openlogspanel="toggleLogsPanel" @save-prj="savePrj()" @clone-prj="cloneProject()" @new-prj="newPrj"></page-header>
                <!--HEADER-->
                <!--BODY-->
                <div :class="[paddingClass]" class="body">
                    <router-view v-if="$route.name !== null"></router-view>
                    <div v-else>
                        <template v-if="mode === 'home'">
                            <!--
                            <into-iframe></into-iframe>
                            -->
                            <template v-if="isIntoIframe">
                                <into-iframe></into-iframe>
                            </template>
                            <template v-else>
                                <home @nav="go($event)" @new-prj="newPrj" @load-prj="!user.guest ? go('projects.my') : go('projects.guest')"></home>
                            </template>
                        </template>
                        <template v-else-if="mode === 'startprj'">
                            <start-prj @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'projects.guest' && user.guest">
                            <prj-finder
                                key="CUSTOMER"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                :rows-number="5"
                                filter="GUEST"
                                order-by="11D"
                                title="My Projects"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.my' && !user.guest">
                            <prj-finder
                                key="MY"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                :rows-number="5"
                                filter="MY"
                                order-by="11D"
                                title="My Projects"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.ext' && !user.guest">
                            <prj-finder
                                key="OTHERPRJ"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'assign', title: null }
                                ]"
                                :rows-number="5"
                                filter="OTHERPRJ"
                                order-by="11D"
                                title="Other Projects In My Store"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.clinv' && !user.guest">
                            <prj-finder
                                key="CLOSED"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'assign', title: null }
                                ]"
                                :rows-number="5"
                                filter="CLOSED"
                                order-by="11D"
                                title="Closed Projects"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <prj-finder
                                key="INACTIVE"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'assign', title: null }
                                ]"
                                :rows-number="5"
                                filter="INACTIVE"
                                order-by="11D"
                                title="Inactive Projects"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'notifications'">
                            <notifications></notifications>
                        </template>
                        <template v-else-if="mode === 'itemsearch'">
                            <article-search @nav="go($event)"></article-search>
                        </template>
                        <template v-else-if="mode === 'renders'">
                            <renders @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'configurator'">
                            <configure :update-picture="false" @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === '3dview' || mode === 'planner'">
                            <view3d ref="conf3d" :load-header-on-start="true" @messagetoiframe="responseToParent($event)" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === '2dview'">
                            <view2d :load-header-on-start="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'compositions'" @nav="go($event)">
                            <compositions :apply-header="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'offerview'">
                            <offer @nav="go($event)"></offer>
                        </template>
                        <template v-else-if="mode === 'summary'">
                            <prj-summary @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'customerinfo'">
                            <customer-info @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'prjlog'">
                            <prj-log @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'delivery'">
                            <delivery @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'promotions'">
                            <promotions @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'myprofile'">
                            <my-profile @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'json'">
                            <d-json :value="prj" />
                        </template>
                        <template v-else>
                            <h1>::::{{ mode }}::::</h1>
                        </template>
                    </div>
                </div>
                <!--BODY-->
            </div>
            <home v-else @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
        </mainindex>
        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
        <modal-set-project-name ref="setProjectName"></modal-set-project-name>
    </div>
</template>
<script>
    import "../../../scss/stiemert.scss";
    import index from "@configurator/index";
    import embedded from "@configurator/embedded";
    import IntoIframe from "./pages/intoIframe";

    import { customImport } from "@/utils";
    import { App, InsertItem2D, ResolveForcedVars, Rule } from "@3cad/nextcore";
    import { bus } from "@store/dau";
    import { CrulesAPI, CsearchAPI } from "@3cad/nextcore";
    import { V_ModalAddLinks, V_ModalDClass, V_ModalPopVar } from "@vuectrls/controllers";
    import NextModals from "@dialogs";
    import { PopVariant } from "@3cad/nextcore";
    import { ResolveAddLinks } from "@3cad/nextcore";

    export default {
        mixins: [index, embedded],
        components: {
            pageHeader: () => customImport("comp/pageHeaderNew.vue"),
            modalSetProjectName: () => import("@custom/dialogs/modalSetProjectName"),
            IntoIframe
        },
        data() {
            return {
                rsaError: false,
                askLeavePage: false
            };
        },
        methods: {
            requestFromParent(action, data) {
                if (this.guestAdmitted) {
                    if (action) {
                        let msgFromParent = {
                            action,
                            data
                        };
                        console.log("messageFromParent", msgFromParent);
                        let newProject, iCatalog, iModel, iHeader, iClassification, iArticle, iSide, idProject, idGallery;
                        switch (action) {
                            case "insertArticle":
                                /*
                                let example = {
                                    "catalog": "TUTORIAL2020",
                                    "model": "999",
                                    "header": "",
                                    "classification": "0102",
                                    "article": "001BA120",
                                    "side": "L",
                                    "newproject": true
                                };
                                */

                                // Check catalog
                                if (!data.catalog) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing catalog"
                                    });
                                    return;
                                }
                                // Check model
                                if (!data.model) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing model"
                                    });
                                    return;
                                }
                                // Check classification
                                if (!data.classification) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing classification"
                                    });
                                    return;
                                }
                                // Check article
                                if (!data.article) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing article"
                                    });
                                    return;
                                }

                                if (data.newproject === null || data.newproject === undefined) {
                                    newProject = true;
                                } else {
                                    newProject = data.newproject;
                                }

                                if (newProject) {
                                    this.initProjectIntoIframe().then(() => {
                                        this.insertArticle(action, data);
                                    });
                                } else {
                                    if (this.mode !== "3dview") {
                                        this.responseToParent({
                                            status: 1,
                                            action: action,
                                            msg: "You must first set model and go to 3D view"
                                        });
                                        return;
                                    }
                                    this.insertArticle(action, data);
                                }
                                break;
                            case "setVariant":
                                /*
                                let example = {
                                    "varName": "_FIN",
                                    "varValue": "516"
                                };
                                */

                                if (this.mode !== "3dview") {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "You must first go to 3D view"
                                    });
                                    return;
                                }

                                // Check varName
                                if (!data.varName) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing variant code"
                                    });
                                    return;
                                }
                                // Check varValue
                                if (!data.varValue) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing variant value"
                                    });
                                    return;
                                }

                                if (this.$refs.conf3d) {
                                    let conf3d = this.$refs.conf3d;
                                    conf3d.changeVariant(data.varName, data.varValue);
                                } else {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "3D view not ready"
                                    });
                                    this.mode = "3dview";
                                }
                                break;
                            case "getJsonProject":
                                /*
                                let example = {};
                                */

                                if (this.prj && this.prj.isopen) {
                                    // let project = JSON.stringify(this.prj);
                                    App.projectManager.recomputePrices().then(response => {
                                        // let encodePrj = this.prj.getJson();
                                        let encodePrj = JSON.parse(JSON.stringify(this.prj));
                                        encodePrj.measures = this.preferences.config.measures;
                                        encodePrj.currency = this.preferences.config.currency;
                                        console.log("getJsonProject:", encodePrj);
                                        this.responseToParent(
                                            {
                                                status: 0,
                                                action: action,
                                                content: encodePrj
                                            },
                                            true
                                        );
                                    });
                                } else {
                                    // alert("No project open")
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "No project open"
                                    });
                                }
                                break;
                            case "saveProject":
                                /*
                                let example = {
                                  "des": "prj description"
                                };
                                */

                                let prjDescription = "";
                                if (data.hasOwnProperty("des")) {
                                    prjDescription = data.des || "";
                                }
                                if (this.prj.des === "" && prjDescription !== "") {
                                    this.prj.des = prjDescription;
                                }

                                if (this.prj.isopen && this.prj.rows.length > 0) {
                                    if (this.prj.des === "") {
                                        this.setProjectName().then(() => {
                                            this.savePrj()
                                                .then(() => {
                                                    this.responseToParent({
                                                        status: 0,
                                                        action: action,
                                                        msg: this.prj.id
                                                    });
                                                })
                                                .catch(error => {
                                                    console.error(action, error);
                                                    this.responseToParent({
                                                        status: 1,
                                                        action: action,
                                                        msg: error
                                                    });
                                                });
                                        });
                                    } else {
                                        this.savePrj()
                                            .then(() => {
                                                this.responseToParent({
                                                    status: 0,
                                                    action: action,
                                                    msg: this.prj.id
                                                });
                                            })
                                            .catch(error => {
                                                console.error(action, error);
                                                this.responseToParent({
                                                    status: 1,
                                                    action: action,
                                                    msg: error
                                                });
                                            });
                                    }
                                } else {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Nothing to save"
                                    });
                                }
                                break;
                            case "openProject":
                                /*
                                let example = {
                                    "id": "2"
                                };
                                */

                                if (!this.isUserLogin) {
                                    this.responseToParent({
                                        status: 0,
                                        action: action,
                                        msg: "You must first do login"
                                    });
                                    return;
                                }

                                // Check id Project
                                if (!data.id) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing id project"
                                    });
                                    return;
                                }
                                idProject = parseInt(data.id);

                                if (this.mode === "3dview") {
                                    this.go("home");
                                }

                                this.openPrj(idProject);
                                break;
                            case "getSnapshot":
                                /*
                                let example = {
                                    "width": "600",
                                    "height": "600"
                                };
                                */

                                let width = 600;
                                // Check if width
                                if (data.width && !isNaN(Number(data.width))) {
                                    width = parseInt(data.width);
                                }
                                let height = 600;
                                // Check if height
                                if (data.height && !isNaN(Number(data.height))) {
                                    height = parseInt(data.height);
                                }

                                if (this.prj && this.prj.isopen) {
                                    if (this.mode === "3dview") {
                                        // width, height, newWindow, bw, keepEffect, true, true, true
                                        let img = App.iCad.scattaFoto(width, height, false, 0, false);
                                        this.responseToParent(
                                            {
                                                status: 0,
                                                action: action,
                                                content: img
                                            },
                                            true
                                        );
                                    } else {
                                        this.responseToParent({
                                            status: 1,
                                            action: action,
                                            msg: "You must first go to 3D view"
                                        });
                                        return;
                                    }
                                } else {
                                    // alert("No project open")
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "No project open"
                                    });
                                    return;
                                }
                                break;
                            case "getTotalPrice":
                                /*
                                let example = {};
                                */

                                if (this.prj && this.prj.isopen) {
                                    App.projectManager
                                        .recomputePrices()
                                        .then(() => {
                                            let total = this.$store.getters["project/total"](true, true, true, true);
                                            this.responseToParent({
                                                status: 0,
                                                action: action,
                                                msg: Math.round((total + Number.EPSILON) * 100) / 100
                                            });
                                        })
                                        .catch(() => {
                                            this.responseToParent({
                                                status: 1,
                                                action: action,
                                                msg: "Error getting prices"
                                            });
                                        });
                                } else {
                                    // alert("No project open")
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "No project open"
                                    });
                                }
                                break;

                            case "navigateTo":
                                /*
                                let example = {
                                    "page": "offerview"
                                };
                                */

                                // Check page routing
                                if (!data.page) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing page to go"
                                    });
                                    return;
                                }

                                let validPages = ["home", "projects", "startprj", "notifications", "itemsearch", "renders", "configurator", "3dview", "planner", "2dview", "compositions", "offerview", "summary", "customerinfo", "prjlog", "delivery", "promotions", "myprofile", "json"];

                                let validPage = validPages.filter(vp => {
                                    return vp.toLowerCase().indexOf(data.page.toLowerCase()) > -1 || data.page.toLowerCase().startsWith("projects");
                                });
                                if (validPage.length > 0) {
                                    this.responseToParent({
                                        status: 0,
                                        action: action,
                                        msg: "Page changed"
                                    });
                                    this.go(data.page);
                                } else {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Unknown page"
                                    });
                                }
                                break;
                            case "setLang":
                                /*
                                let example = {
                                    "lang": "IT"
                                };
                                */

                                // Check language
                                if (!data.lang) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing lang"
                                    });
                                    return;
                                }
                                App.setLang(data.lang).then(() => {
                                    this.responseToParent({
                                        status: 0,
                                        action: action,
                                        msg: "Language changed"
                                    });
                                    this.go("home");
                                });
                                break;
                            default:
                                console.log(data);
                                this.responseToParent({
                                    status: 1,
                                    action: action,
                                    msg: "Unknown action"
                                });
                                break;
                        }
                    } else {
                        // console.log("Missing Action");
                    }
                } else {
                    this.responseToParent({
                        status: 1,
                        action: "APP",
                        msg: "This site doesn't allow guest users!"
                    });
                }
            },
            initProjectIntoIframe() {
                return new Promise((resolve, reject) => {
                    let initPrj = () => {
                        if (localStorage["next_goto"]) {
                            delete localStorage["next_goto"];
                        }
                        if (this.preferences.config.customerAssignment && !this.user.guest) {
                            this.$3cadComponent({
                                title: this._trans("Customer assignment"),
                                component: "_retrieveCustomer",
                                componentData: {},
                                componentEvents: ["select", "skip"]
                            }).then(({ event, data }) => {
                                this.$store.commit("project/empty");
                                this.$store.commit("erp/reset");
                                this.resetCustomerParams();
                                //Empty breadcrumb store
                                if (this.$store.state.searchArticle) {
                                    this.$store.unregisterModule("searchArticle");
                                }
                                let customerData = data;
                                if (customerData) {
                                    this.prj.customercod = customerData.email;
                                }
                                this.prj.isopen = true;
                                resolve();
                            });
                        } else {
                            this.$store.commit("project/empty");
                            this.$store.commit("erp/reset");
                            this.resetCustomerParams();
                            //Empty breadcrumb store
                            if (this.$store.state.searchArticle) {
                                this.$store.unregisterModule("searchArticle");
                            }
                            this.prj.isopen = true;
                            resolve();
                        }
                    };

                    if (this.mode === "3dview") {
                        this.go("home");
                    }
                    if (this.prj.isopen) {
                        this.$3cadAsk({
                            title: this._trans("Project not saved"),
                            body: this._trans("Save current project?"),
                            okTitle: this._trans("Yes"),
                            cancelTitle: this._trans("No")
                        })
                            .then(() => {
                                this.savePrj().then(initPrj);
                            })
                            .catch(mode => {
                                if (mode === 0) initPrj();
                            });
                    } else {
                        initPrj();
                    }
                });
            },
            insertArticle(action, data) {
                let iCatalog = data.catalog;
                let iModel = data.model;
                let iHeader = data.header ? data.header : "";
                let iClassification = data.classification;
                let iArticle = data.article;
                let iSide = data.side ? data.side : "L";
                bus.$emit("startLoading");
                CsearchAPI.getModels(
                    iCatalog,
                    iModel,
                    "",
                    jsonModels => {
                        if (jsonModels.length === 1) {
                            let data = {
                                Catalogo: iCatalog,
                                cmodel: jsonModels[0].cod,
                                model: jsonModels[0].basemodel,
                                fldef: jsonModels[0].fldef + "\t" + iHeader,
                                forcedvar: Rule.joinvariants(jsonModels[0].forcedvariants || ""),
                                defaultvar: Rule.joinvariants(jsonModels[0].defaultvariants || ""),
                                datalimits: 0
                            };
                            CrulesAPI.headerSet(
                                data,
                                headerRule => {
                                    let curHeader = new Rule(headerRule);
                                    let strHeader = "\t";
                                    if (curHeader && curHeader.reg) {
                                        let v = curHeader.reg.split("\t");
                                        let v1 = [];
                                        for (let i = 0; i < v.length; i++) {
                                            if (v[i].indexOf("=") > 0) {
                                                if (v[i].split("=")[0].toUpperCase() !== "MODELLO") v1.push(v[i]);
                                            }
                                        }
                                        strHeader = v1.join(";");
                                    }
                                    let model = {
                                        des: jsonModels[0].des,
                                        cmodel: curHeader.cModel,
                                        cod: curHeader.model,
                                        header: strHeader
                                    };
                                    this.$store.commit("project/addHistory", { catalog: iCatalog, model: model });
                                    this.$set(this.prj, "currency", this.preferences.config.currency || "EUR");
                                    this.prj.isopen = true;
                                    console.log(this.prj.history);
                                    let dataToSend = {
                                        catalog: iCatalog,
                                        model: iModel,
                                        classification: iClassification,
                                        article: iArticle,
                                        side: iSide
                                    };
                                    CsearchAPI.getItemTip(
                                        dataToSend.catalog,
                                        dataToSend.model,
                                        dataToSend.classification,
                                        jsonArticles => {
                                            if (jsonArticles.length > 0) {
                                                let selectedArt = jsonArticles.find(art => {
                                                    return art.cod === dataToSend.article;
                                                });
                                                if (selectedArt) {
                                                    if (this.mode !== "3dview") {
                                                        let insertItem = new InsertItem2D(App.getLoaderManager());
                                                        let modalVariant = new V_ModalPopVar(NextModals.popVariant);
                                                        let modalDclass = new V_ModalDClass(
                                                            NextModals.popDclass,
                                                            {
                                                                size: "xl",
                                                                dialogClass: "modal-full"
                                                            },
                                                            App.getConfig().dclass
                                                        );
                                                        let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
                                                        let forcedResolver = new ResolveForcedVars(popVariant);
                                                        let modalAddLinks = new V_ModalAddLinks(NextModals.component, {
                                                            title: this._trans("Choose item position"),
                                                            component: "listViewer",
                                                            componentData: {
                                                                data: {}
                                                            },
                                                            componentEvents: ["select"]
                                                        });
                                                        let addLinksResolver = new ResolveAddLinks(modalAddLinks, App.getConfig().config.optionscad2d);
                                                        let el = {
                                                            side: data.side,
                                                            item: selectedArt
                                                        };

                                                        insertItem
                                                            .insert(el, this.prj, App.getICad(), forcedResolver, addLinksResolver)
                                                            .then(() => {
                                                                this.responseToParent({
                                                                    status: 0,
                                                                    action: action,
                                                                    msg: "Article added correctly"
                                                                });
                                                                this.go("3dview");
                                                            })
                                                            .catch(err => {
                                                                bus.$emit("stopLoading");
                                                                throw err;
                                                            });
                                                    } else {
                                                        bus.$emit("stopLoading");
                                                        this.$refs.conf3d.loadItem(
                                                            {
                                                                side: data.side,
                                                                item: selectedArt
                                                            },
                                                            true
                                                        );
                                                    }
                                                } else {
                                                    bus.$emit("stopLoading");
                                                    this.responseToParent({
                                                        status: 1,
                                                        action: action,
                                                        msg: "Article not found"
                                                    });
                                                }
                                            } else {
                                                bus.$emit("stopLoading");
                                                this.responseToParent({
                                                    status: 1,
                                                    action: action,
                                                    msg: "Article not found"
                                                });
                                            }
                                        },
                                        error => {
                                            bus.$emit("stopLoading");
                                            this.responseToParent({
                                                status: 1,
                                                action: action,
                                                msg: error
                                            });
                                        }
                                    );
                                },
                                errorHeaderSet => {
                                    bus.$emit("stopLoading");
                                    console.error("errorHeaderSet", errorHeaderSet);
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: errorHeaderSet
                                    });
                                }
                            );
                        } else if (jsonModels.length === 0) {
                            bus.$emit("stopLoading");
                            this.responseToParent({
                                status: 1,
                                action: action,
                                msg: "Model unknown"
                            });
                        } else {
                            bus.$emit("stopLoading");
                            console.warn("jsonModels error", jsonModels);
                        }
                    },
                    errorGetModel => {
                        bus.$emit("stopLoading");
                        console.error("errorGetModel", errorGetModel);
                        this.responseToParent({
                            status: 1,
                            action: action,
                            msg: errorGetModel
                        });
                    }
                );
            },
            onNewProject() {
                this.go("itemsearch");
            },
            setProjectName() {
                return new Promise((resolve, reject) => {
                    this.$refs.setProjectName
                        .open({
                            noCloseOnBackdrop: true,
                            noCloseOnEsc: true,
                            hideHeaderClose: true
                        })
                        .$once("close", (mode, data) => {
                            if (mode === 1) {
                                resolve();
                            } else {
                                reject();
                            }
                        });
                });
            },
            onProjectLoaded() {
                if (this.isIntoIframe) {
                    this.responseToParent({
                        status: 0,
                        action: "openProject",
                        msg: "Project loaded correctly"
                    });
                }
                this.go("3dview");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/custom/stiemert/start.vue